require("./setup");
require("./config/moment-config");
global.jQuery = global.$ = require("jquery");
global.api = require("lib/api").default;
global.busy = require("lib/busy").default;
global.luvit = require("./common");
global.sessionvars = require("lib/config.js");
require("moment-timezone/builds/moment-timezone-with-data-2012-2022");
global.moment = require("moment");
global.format = require("lib/format");
require("custom-event-polyfill");
require("./plugins/jquery.responsiveTabs.js");
require("./plugins/jquery.touchSwipe.min.js");
require("lib/zoom");
